module.exports = __webpack_public_path__ + "static/media/badge-Apple.6a150a74.svg";